import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { LayoutService } from '../../layout.service';
import * as g from 'src/app/globals';
import { RecordListDrawerArgs } from 'src/app/models/record-list-drawer-args';
import {
  Field,
  FieldDataType,
  ModuleStructure,
} from 'src/app/models/module-structure';
import { RecordsListComponent } from '../../records-list/records-list.component';
import { differenceInCalendarDays, setHours } from 'date-fns';
import { DisabledTimeFn, DisabledTimePartial } from 'ng-zorro-antd/date-picker';
import * as moment from 'moment';
import * as accounting from 'accounting';

@Component({
  selector: 'app-wizard-filter-section',
  templateUrl: './wizard-filter-section.component.html',
  styleUrls: ['./wizard-filter-section.component.less'],
})
export class WizardFilterSectionComponent implements OnInit {
  @Input() groupedFilterFields: any[][];
  @Input() groupKeys: string[];
  groupKeysTitles: { [key: string]: string };
  @Input() filterButtonIsLoading = false;
  @Input() filterFooter: TemplateRef<any>;
  @Input() filterFooterVisible = true;
  @Input() sectionId = 0;
  @Input() actionType = '';
  @Input() columnWidthPercent = '';
  @Input() customerCode = '';
  @Input() fieldsToShow: Set<string>;
  @Input() embdedSection = false;
  @Input() okButtonLabel = 'Ok';
  @Input() showCancelButton = true;
  filterFieldsVal: any[];
  firstGroupKeyWithTitle: string;
  @Input() set filterFields(value: any[]) {
    if (
      value != null &&
      value !== undefined &&
      value['filterFields'] != null &&
      value['filterFields'] !== undefined
    ) {
      this.filterFieldsVal = value['filterFields'];
    } else {
      this.filterFieldsVal = value;
    }
    this.getFilterGrouped();
    this.getFilterGroupKeys();
  }

  get filterFields(): any[] {
    return this.filterFieldsVal;
  }

  @Output() filterFieldsChange = new EventEmitter<{
    fieldName: string;
    filterFields: any[];
  }>();

  //@Output() filterFieldsChange = new EventEmitter<any[]>();

  @Output() filterButtonClicked = new EventEmitter();
  @Output() okButtonClicked = new EventEmitter();
  @Output() cancelButtonClicked = new EventEmitter();

  fieldWorkingOn: any;
  selectedRecords: string[] = [];
  options: { value: string | number; label: string }[] = [];
  term = '';
  global = g;

  today = new Date();
  formatterPercent = (value: number) => `${value} %`;
  parserPercent = (value: string) => value.replace(' %', '');

  formatterQuantity(value: number): string {
    if (value == null || isNaN(value)) {
      value = 0;
    }

    return accounting.formatNumber(
      value,
      g.companyConfiguration.QuantityDecimal,
      g.companyConfiguration.ThousandSep,
      g.companyConfiguration.DecimalSep
    );
  }
  numberParser(value: string) {
    if (value == null) {
      return '';
    } else {
      return value.replace('%', '').replace(' ', '');
    }
  }

  disabledDate = (current: Date): boolean =>
    // Can not select days before today and today
    differenceInCalendarDays(current, this.today) < 5;

  constructor(
    private layoutService: LayoutService,
    private drawerService: NzDrawerService
  ) {}

  ngOnInit(): void {
    console.log('ngOnInit: Wizard filter');
    // commented because it is called twice
    if (this.sectionId !== 0) {
      setTimeout(() => {
        if (
          this.filterFields == null ||
          this.filterFields === undefined ||
          this.filterFields.length === 0
        ) {
          this.getFilterFields();
        }
      }, 2000);
    }

    /*
    this.fieldGroups = this.filterFields.reduce(function (acc, obj) {
      let key = obj.AdditionalInformationParsed.GroupInDialog;
      if (key === 'null' || key === null) {
        key = 'NOT_GROUPED';
      }
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(obj);
      return acc;
    }, {});

    console.log(this.fieldGroups);*/
  }

  /*fieldsChanged(field: any) {
    this.filterFieldsChange.emit({
      fieldName: field.FieldName,
      filterFields: this.filterFields,
    });
  }*/

  fieldsChanged(fieldName: string) {
    this.filterFieldsChange.emit({
      fieldName,
      filterFields: this.filterFields,
    });
  }

  /*adjustDateVals(filterField: any): void {
    if (filterField.Value !== null) {
      filterField.Value = moment(
        new Date(filterField.Value).setHours(0, 0, 0, 0)
      ).format('yyyy-MM-DD');
    }
  }*/

  adjustDateVals(filterField: any): void {
    if (filterField.Value !== null) {
      filterField.Value = moment(
        new Date(filterField.Value).setHours(0, 0, 0, 0)
      ).format('yyyy-MM-DD');
    }
  }

  emitFilterButton() {
    this.filterButtonClicked.emit();
  }

  emitCancelButton() {
    this.cancelButtonClicked.emit();
  }

  emitOkButton() {
    this.okButtonClicked.emit();
  }

  formatterNumber(value: number): string {
    if (value == null || value === 0 || isNaN(value)) {
      return '';
    }

    return `${Number(value).toFixed(0).toString()}`;
  }

  onSearch(value: string, field: any): void {
    this.getOptions(field);
  }

  getOptions(field: any) {
    if (field.SQLStatementId === undefined || field.SQLStatementId === null) {
      return;
    }

    const paramsNames = g.queriesData[field.SQLStatementId];
    const vals: string[] = [];

    this.layoutService
      .getSelectValues(
        null,
        '',
        field.Id,
        field.SQLStatementId,
        paramsNames,
        vals
      )
      .subscribe((d: any) => {
        field.Options = d.Values.rowsArray;
      });
  }

  async openSearchDrawer(field: Field) {
    const args: RecordListDrawerArgs = {
      parentComponent: this,
      moduleId: Number(field.LinkedModule),
      inDrawer: true,
      isSingleSelection: true,
      linkedFieldId: field.Id,
      linkedFieldSectionTagName: '',
      term: this.term,
      lineId: 0,
      recordModel: undefined,
    };

    this.fieldWorkingOn = field;
    RecordsListComponent.openRecordListDrawer(this.drawerService, args);
  }

  selectionChanged(event) {
    this.selectedRecords = event;
  }

  removeSelection(field: any) {
    field.Value = '';
    this.term = '';
    this.fieldsChanged(field.FieldName);
  }

  validateSelection(field: Field, value: string) {
    field['Value'] = value;
    const body = {
      moduleId: field.LinkedModule,
      term: value,
      linkedFieldId: field.Id,
      valuesToPass: [],
    };

    this.layoutService
      .getAutoCompleteValidate(body)
      .subscribe((d: { OneResult: boolean; Value: string }) => {
        if (d.OneResult) {
          // tslint:disable-next-line: no-string-literal
          field['Value'] = d.Value;
          this.submitSelection();
          this.fieldsChanged(field.FieldName);
        } else {
          this.term = value;
          value = '';
          this.openSearchDrawer(field);
        }
      });
  }

  onType(e: Event, field: Field): void {
    const value = (e.target as HTMLInputElement).value;
    field['Value'] = value;
    const body = {
      moduleId: field.LinkedModule,
      term: value,
      linkedFieldId: field.Id,
      valuesToPass: [],
    };

    this.layoutService
      .getAutoCompleteType(body)
      .subscribe(
        (d: {
          Count: number;
          Rows: { value: string | number; label: string }[];
        }) => {
          this.options = d.Rows;
        }
      );
  }

  getFilterFields(): void {
    this.layoutService.getFilterFields(this.sectionId).subscribe((d: any) => {
      let existingValues: { PropertyName: string; Value: any }[];

      if (this.filterFields !== undefined) {
        existingValues = this.filterFields.map((f) => {
          return { PropertyName: f.PropertyName, Value: f.Value };
        });
      }
      this.filterFields = [];
      this.filterFields = [...d.Data.fields];
      this.filterFields.forEach((element) => {
        let existingValue;
        if (existingValues !== undefined) {
          existingValue = existingValues.find(
            (f) => f.PropertyName === element.PropertyName
          );
        }

        if (
          existingValue === undefined &&
          element.DefaultValueSQLStatementId !== undefined &&
          element.DefaultValueSQLStatementId != null
        ) {
          this.layoutService
            .getDefaultValue(element.DefaultValueSQLStatementId)
            .subscribe((res: any) => {
              if (element.DataType === FieldDataType.Date) {
                if (
                  res.DefaultValue !== undefined &&
                  res.DefaultValue !== null &&
                  res.DefaultValue.toString().startsWith('/Date(')
                ) {
                  /*res.DefaultValue = res.DefaultValue.replace(
                    '/Date(',
                    ''
                  ).replace(')/', '');*/
                  element.Value = moment.utc(res.DefaultValue).toDate();
                }
              } else {
                element.Value = res.DefaultValue;
                if (element.DataType === FieldDataType.Select) {
                  if (element.AdditionalInformationParsed?.IsMultiple) {
                    element.Value = [element.Value.toString()];
                  } else {
                    element.Value = element.Value.toString();
                  }
                }
              }
              //this.filterFieldsChange.emit(this.filterFields);
              this.filterFieldsChange.emit({
                fieldName: element.FieldName,
                filterFields: this.filterFields,
              });
            });
        } else {
          if (existingValue !== undefined) {
            element.Value = existingValue.Value;
          }
        }
      });
    });
  }

  getFilterGroupKeys() {
    if (this.filterFields === undefined) {
      return;
    }
    this.groupKeys = [];
    this.groupKeysTitles = {};
    this.filterFields.forEach((element) => {
      let key = element.AdditionalInformationParsed?.GroupInDialog;
      if (key === 'null' || key === null) {
        key = '';
      }
      if (this.groupKeys.indexOf(key) === -1) {
        this.groupKeys.push(key);

        if (element.AdditionalInformationParsed?.GroupInDialogTitle != null) {
          this.groupKeysTitles[key] =
            element.AdditionalInformationParsed?.GroupInDialogTitle;
        }
      }
    });

    this.groupKeys = this.groupKeys.sort();
    this.firstGroupKeyWithTitle = this.groupKeys.find(
      (key) =>
        this.groupKeysTitles[key] != null &&
        this.groupKeysTitles[key].trim() !== ''
    );
  }

  getFilterGrouped() {
    if (this.filterFields === undefined) {
      return;
    }
    this.groupedFilterFields = this.filterFields.reduce((acc, obj) => {
      let key = obj.AdditionalInformationParsed?.GroupInDialog;
      if (key === 'null' || key === null) {
        key = '';
      }
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(obj);
      return acc;
    }, {});

    console.log(this.groupedFilterFields);
  }

  submitSelection() {
    if (this.fieldWorkingOn === undefined) {
      return;
    }
    this.layoutService
      .getModuleHeaderData(
        this.fieldWorkingOn.LinkedModule,
        this.selectedRecords[0],
        '',
        false
      )
      .subscribe((d) => {
        console.log('header data', d);
        if (
          this.fieldWorkingOn.LinkedField == null ||
          this.fieldWorkingOn.LinkedField === undefined ||
          this.fieldWorkingOn.LinkedField === ''
        ) {
          this.fieldWorkingOn.Value = this.selectedRecords[0];
          this.term = '';
        } else {
          this.fieldWorkingOn.Value = d[this.fieldWorkingOn.LinkedField];
          this.term = '';
        }
      });
  }

  preview(value) {
    window.open(
      g.apiBaseUrl +
        'media/previewfile?path=' +
        encodeURI(value) +
        '&' +
        g.getUrlSuffix()
    );
  }
}
